// eslint-disable-next-line import/no-named-as-default
import ResetPassword from './ResetPassword'
import enhance from './ResetPassword.enhancer'

export default enhance(ResetPassword)
